import createTeamListProcess from "./team-list.js";

createTeamListProcess({
    teams: ["fabled", "loric"],
    listSelector: "#fabled-list__list",
    addButtonSelector: "#add-fabled",
    dialogSelector: "#fabled-list"
});
